import React from 'react'
import PropTypes from 'prop-types'
import { map, cond, always, T, prop, isEmpty } from 'ramda'
import { useSelector } from 'hooks/redux'
import strings from 'utils/strings'
import { Button } from 'components/patterns'

import { getPtoTemplateDiff } from 'selectors/powerTakeOff'

const PTO_DIFF_VIEW = 'PTO_DIFF_VIEW'
const NOTES_VIEW = 'NOTES_VIEW'
const TEMPLATE_SELECT_VIEW = 'TEMPLATE_SELECT_VIEW'
const getViewType = cond([
  [prop('isPtoDiffView'), always(PTO_DIFF_VIEW)],
  [prop('isNotesView'), always(NOTES_VIEW)],
  [T, always(TEMPLATE_SELECT_VIEW)],
])

const PtoTemplateActionButtons = ({
  isPtoDiffView,
  isNotesView,
  notes,
  submitting,
  handleDrawerAndClearTemplate,
  handleSetToNotesView,
  handleCancelToTemplateView,
  handleCancelToDiffView,
  handleApplyWithNotes,
  selectedTemplateId,
}) => {
  const conditions = {
    isPtoDiffView,
    isNotesView,
  }
  const diffListByTemplateId = useSelector(getPtoTemplateDiff, {
    templateId: selectedTemplateId,
  })
  const hasDiff = !isEmpty(diffListByTemplateId)
  const viewType = getViewType(conditions)
  const applyTemplateButtons = {
    [TEMPLATE_SELECT_VIEW]: [
      {
        onClick: handleDrawerAndClearTemplate,
        type: 'secondary',
        disabled: false,
        text: strings.cancel,
      },
    ],
    [PTO_DIFF_VIEW]: [
      {
        onClick: handleCancelToTemplateView,
        type: 'secondary',
        disabled: false,
        text: strings.cancel,
      },
      {
        onClick: handleSetToNotesView,
        type: 'primary',
        disabled: !hasDiff,
        text: strings.apply_pto_template_button,
      },
    ],
    [NOTES_VIEW]: [
      {
        onClick: handleDrawerAndClearTemplate,
        type: 'secondary',
        disabled: submitting,
        text: strings.cancel,
      },
      {
        onClick: handleApplyWithNotes,
        type: 'primary',
        loading: submitting,
        disabled: notes.length === 0,
        text: strings.save,
      },
    ],
  }

  const renderButtons = map((buttonProps) => {
    const { text, ...rest } = buttonProps
    return (
      <Button key={text} {...rest}>
        {text}
      </Button>
    )
  })

  return renderButtons(applyTemplateButtons[viewType])
}

PtoTemplateActionButtons.propTypes = {
  handleDrawerAndClearTemplate: PropTypes.func,
  handleCancelToTemplateView: PropTypes.func,
  handleSetToNotesView: PropTypes.func,
  handleCancelToDiffView: PropTypes.func,
  handleApplyWithNotes: PropTypes.func,
  selectedTemplateId: PropTypes.string,
  isPtoDiffView: PropTypes.bool,
  isNotesView: PropTypes.bool,
  notes: PropTypes.string,
  submitting: PropTypes.bool,
}

export default PtoTemplateActionButtons
